<app-form-field-render [field]="self">
  <ng-select
    #select
    [items]="items"
    [multiple]="true"
    [closeOnSelect]="false"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [placeholder]="placeholder"
    [virtualScroll]="true"
    [compareWith]="compareWith"
    appendTo="body"
    [formControl]="ctrl"
    (change)="onValueChange($event)"
    (search)="onSearch($event)"
    (open)="onSelectDropdownOpen()"
    (close)="onSelectDropdownClose()"
    [ngClass]="'form-control'"
    [class.is-invalid]="isTouchedInvalid"
  >
    <ng-template ng-multi-label-tmp let-selected="items" let-clearItem>
      <ng-template
        [ngTemplateOutlet]="selectSelectedLabel?.templateRef || defaultOptionLabelTemplate"
        [ngTemplateOutletContext]="{ selected: selected, label: getSelectedLabels(selected) }"
      >
      </ng-template>
    </ng-template>

    <ng-template ng-header-tmp>
      <div class="custom-select-header">
        <div class="custom-control custom-checkbox master-toggle">
          <input
            type="checkbox"
            class="custom-control-input"
            id="master-toggle"
            [formControl]="masterToggleCtrl"
            [indeterminate]="isMasterToggleIndeterminate"
          />
          <label class="custom-control-label" for="master-toggle">&nbsp;</label>
        </div>
        <div class="custom-select-search-wrapper">
          <input #customSearchInput class="custom-select-search pl-1" type="text" [formControl]="searchCtrl" />
          <span class="custom-search-clear" *ngIf="searchCtrl.value" (click)="onClearSearch()">×</span>
        </div>
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
      <div class="custom-control custom-checkbox item-checkbox" (click)="onItemClick($event, item$)">
        <input type="checkbox" class="custom-control-input" id="item-checkbox-{{ index }}" [checked]="item$.selected" />
        <label class="custom-control-label w-100" for="item-checkbox-{{ index }}">
          <ng-template
            [ngTemplateOutlet]="selectOptionLabel?.templateRef || defaultOptionLabelTemplate"
            [ngTemplateOutletContext]="{ item: item, index: index, label: getItemLabel(item) }"
          >
          </ng-template>
        </label>
      </div>
    </ng-template>
  </ng-select>
</app-form-field-render>

<!--  Template -->
<ng-template #defaultOptionLabelTemplate let-label="label">
  <div class="text-truncate">{{ label }}</div>
</ng-template>
